import {
	Box,
	Stack,
	StackDivider,
	Heading,
	Text,
	useColorModeValue
} from '@chakra-ui/react';
import { toDollarFormat } from 'utils/format';
import { PortfolioTooltipData } from '../types';
import GrowthBadge from '../../Badge/GrowthBadge';
import { PortfolioModel } from 'models/Portfolio/Portfolio';

interface PortfolioValueTooltipProps extends PortfolioTooltipData {
	data?: PortfolioModel[];
}

export default function PortfolioValueTooltip(props: PortfolioValueTooltipProps) {
	const { payload, active, label } = props;
	const backgroundColor = useColorModeValue("white", "black");
	
	if (!active || !payload || payload.length === 0) return null;
	
	const portfolioData: PortfolioModel = payload?.[0]?.payload?.data;
	const value = payload?.[0]?.value;
	const percentage = payload?.[0].payload?.percentage;

	if (!portfolioData) return null;

	return (
		<Box borderWidth="1px" borderRadius="lg" p={4} shadow="md" backgroundColor={backgroundColor} zIndex={10}>
			{!!label && <Box mb={4}>
				<Heading size='md'>{label}</Heading>
			</Box>}
			<Stack divider={<StackDivider />} spacing='4' textAlign={'left'}>
				<Box>
					<Text fontSize='xs' textTransform='uppercase'>
						Portfolio Value
					</Text>
					<Heading pt='2' fontSize='sm'>
						${value}
					</Heading>
				</Box>
				{!!percentage && (
					<Box>
						<Text fontSize='xs' textTransform='uppercase'>
							Growth
						</Text>
						<Heading pt='2' fontSize='sm'>
							{percentage}%
						</Heading>
					</Box>
				)}
			</Stack>
		</Box>
	);
}
